import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { UserState } from '@store/root-store/auth/auth.reducer';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthFacadeService } from '@store/root-store/auth/auth-facade.service';
import { PermissionService } from '../core/permission.service';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard {
  constructor(
    private router: Router,
    private authFacade: AuthFacadeService,
    private permissionService: PermissionService,
  ) {}

  canActivate(next: ActivatedRouteSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.authFacade.state$.pipe(
      map((userState: UserState) => {
        if (!next.data.roles) {
          if (!userState.isAuthenticated) {
            this.router.navigateByUrl('/auth');
          }
          return userState.isAuthenticated;
        }

        if (this.permissionService.hasPermission(next.data.roles)) {
          return true;
        }

        this.router.navigateByUrl('/auth');
        return false;
      }),
    );
  }
}
